<template>
  <div :class="bem()">
    <div
      v-if="block.content"
      :class="bem('title')"
    >
      <GenericStructuredText
        :class="bem('generic-content')"
        :content="block.content"
        copy-size="body-sm"
        cta-size="x-small"
      />
    </div>
    <InstagramGrid
      :posts="block.posts"
      :desktop-rows="block.rows"
      :products="(block.instashopProducts || []).map((p) => p.id)"
      :tracking-id="block.trackingId"
      :unique-id="block.id"
    />
  </div>
</template>

<script setup>
const bem = useBEM('InstagramShopRow')

defineProps({
  block: { type: Object, required: true },
})
</script>

<style lang="postcss">
.InstagramShopRow {
  @apply w-full;
}

.InstagramShopRow__title {
  @apply global-wrapper w-full mb-5;
}

.InstagramShopRow__generic-content .GenericStructuredText__content {
  @apply gap-2;
}
</style>
